import { createApp } from 'vue';
import { useTheme } from '@skillstown/leap';
import '@skillstown/leap/dist/style.css';
import { i18n } from './languages';
import App from './App.vue';
import { router } from './router/router';
import { msalPlugin, msalInstance } from './auth';
import { type AccountInfo, EventType } from '@azure/msal-browser';
import { CustomNavigationClient } from './router/navigationClient';

const { initialTheme, prefersDark } = useTheme();
if (window.localStorage.getItem('theme') === 'light') prefersDark.value = false;
if (window.localStorage.getItem('theme') === 'dark') prefersDark.value = true;
initialTheme();

// The next 2 lines are optional. This is how we can configure MSAL to take advantage of the router's navigate functions when MSAL redirects between pages in our app
const navigationClient = new CustomNavigationClient(router);
msalInstance.setNavigationClient(navigationClient);

// Account selection logic is app dependent. Adjust as needed for different use cases.
const accounts = msalInstance.getAllAccounts();
if (accounts?.length) {
  msalInstance.setActiveAccount(accounts[0]);
}
msalInstance.addEventCallback((event) => {
  if (event.eventType === EventType.LOGIN_SUCCESS && event.payload) {
    const payload = event.payload as AccountInfo;
    msalInstance.setActiveAccount(payload);
  }
});

const app = createApp(App);

app.use(router);
app.use(msalPlugin, msalInstance);
app.use(i18n);

router.isReady().then(() => {
  // Waiting for the router to be ready prevents race conditions when returning from a loginRedirect or acquireTokenRedirect
  app.mount('#app');
});
